function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../../lib/utils';
const avatarVariants = cva('relative flex shrink-0 overflow-hidden rounded-full', {
    variants: {
        size: {
            sm: 'size-6',
            md: 'size-12',
            lg: 'size-24',
            xl: 'size-32'
        }
    },
    defaultVariants: {
        size: 'sm'
    }
});
function Avatar(_0) {
    let { className, size } = _0, props = _object_without_properties(_0, [
        "className",
        "size"
    ]);
    return /*#__PURE__*/ _jsx(AvatarPrimitive.Root, _object_spread({
        "data-slot": "avatar",
        className: cn(avatarVariants({
            size
        }), className)
    }, props));
}
function AvatarImage(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(AvatarPrimitive.Image, _object_spread({
        "data-slot": "avatar-image",
        className: cn('aspect-square size-full', className)
    }, props));
}
const avatarFallbackVariants = cva('flex size-full items-center justify-center rounded-full', {
    variants: {
        size: {
            sm: 'text-xs',
            md: 'text-sm',
            lg: 'text-base',
            xl: 'text-lg',
            xxl: 'text-xl'
        }
    },
    defaultVariants: {
        size: 'md'
    }
});
function AvatarFallback(_0) {
    let { className, size } = _0, props = _object_without_properties(_0, [
        "className",
        "size"
    ]);
    return /*#__PURE__*/ _jsx(AvatarPrimitive.Fallback, _object_spread({
        "data-slot": "avatar-fallback",
        className: cn(avatarFallbackVariants({
            size
        }), className, 'text-white')
    }, props));
}
export { Avatar, AvatarFallback, AvatarImage, avatarVariants };
